import { Injectable } from '@angular/core'
import { Router } from '@angular/router'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { of } from 'rxjs'
import { catchError, map, switchMap } from 'rxjs/operators'
import {
  CreateIndustryFailure,
  CreateIndustryRequest,
  CreateIndustrySuccess,
  DeleteIndustryFailure,
  DeleteIndustryRequest,
  DeleteIndustrySuccess,
  FetchIndustriesFailure,
  FetchIndustriesRequest,
  FetchIndustriesSuccess,
  FetchIndustryFailure,
  FetchIndustryRequest,
  FetchIndustrySuccess,
  UpdateIndustryFailure,
  UpdateIndustryRequest,
  UpdateIndustrySuccess,
} from './industries.actions'
import { IndustriesService } from './industries.service'
import * as IndustriesTypes from './industries.types'

@Injectable()
export class IndustriesEffects {
  constructor(
    private actions: Actions,
    private industriesService: IndustriesService,
    private router: Router,
  ) {}

  FetchIndustries$ = createEffect(() =>
    this.actions.pipe(
      ofType(IndustriesTypes.FETCH_INDUSTRIES_REQUEST),
      switchMap((action: FetchIndustriesRequest) => {
        return this.industriesService.fetchIndustries(action.payload).pipe(
          map((result) => {
            return new FetchIndustriesSuccess(
              result.data.industries,
              result.data.filteredCount,
            )
          }),
          catchError((err, caught) => {
            return of(new FetchIndustriesFailure({ error: err }))
          }),
        )
      }),
    ),
  )

  FetchIndustry$ = createEffect(() =>
    this.actions.pipe(
      ofType(IndustriesTypes.FETCH_INDUSTRY_REQUEST),
      switchMap((action: FetchIndustryRequest) => {
        return this.industriesService.fetchIndustry(action.id).pipe(
          map((result) => {
            return new FetchIndustrySuccess(result.data)
          }),
          catchError((err, caught) => {
            return of(new FetchIndustryFailure({ error: err }))
          }),
        )
      }),
    ),
  )

  DeleteIndustry$ = createEffect(() =>
    this.actions.pipe(
      ofType(IndustriesTypes.DELETE_INDUSTRY_REQUEST),
      switchMap((action: DeleteIndustryRequest) => {
        return this.industriesService.deleteIndustry(action.id).pipe(
          switchMap((result) => {
            return [new DeleteIndustrySuccess()]
          }),
          catchError((err, caught) => {
            return of(new DeleteIndustryFailure({ error: err }))
          }),
        )
      }),
    ),
  )

  CreateIndustry$ = createEffect(() =>
    this.actions.pipe(
      ofType(IndustriesTypes.CREATE_INDUSTRY_REQUEST),
      switchMap((action: CreateIndustryRequest) => {
        return this.industriesService.createIndustry(action.payload).pipe(
          switchMap((result) => {
            this.router.navigate(['/admin/industries'])
            return [new CreateIndustrySuccess()]
          }),
          catchError((err, caught) => {
            return of(new CreateIndustryFailure({ error: err }))
          }),
        )
      }),
    ),
  )

  UpdateIndustry$ = createEffect(() =>
    this.actions.pipe(
      ofType(IndustriesTypes.UPDATE_INDUSTRY_REQUEST),
      switchMap((action: UpdateIndustryRequest) => {
        return this.industriesService
          .updateIndustry(action.id, action.payload)
          .pipe(
            switchMap((result) => {
              this.router.navigate(['/admin/industries'])
              return [new UpdateIndustrySuccess()]
            }),
            catchError((err, caught) => {
              return of(new UpdateIndustryFailure({ error: err }))
            }),
          )
      }),
    ),
  )
}
